/**
 * Ask Argus — Layout route
 *
 * Wraps all /ask-argus/* child routes.
 * Child routes:
 *   /ask-argus/           — Main chat interface
 *   /ask-argus/projects   — Projects page (Claude-style)
 *   /ask-argus/project/$projectId — Project detail with scoped chat
 */

import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/ask-argus')({
  component: AskArgusLayout,
});

function AskArgusLayout() {
  return <Outlet />;
}
